function getDateFromString(value) {
    let dateArray = value.split('-');

    let year = +dateArray[0];
    let month = +dateArray[1] - 1;
    let day = +dateArray[2];

    return new Date(year, month, day);
}

export function dateLessThenCurrent(value) {
    if(value === '')
        return true;

    const valueDate = getDateFromString(value);

    const currentDate = new Date();

    return valueDate.getTime() <= currentDate.getTime();
}

export const dateGreaterThan = (year, month, day) => {
    return (value) => {
        if(value === '')
            return true;

        const valueDate = getDateFromString(value);

        const tempDate = new Date(year, month, day);

        return valueDate.getTime() >= tempDate;
    }
} // dateGreaterThan.

export function dateRequired(value) {
    return value !== '';
}